import React, { Component } from 'react';
import { pick } from 'ramda';
import { Container, Row, Col, Card, CardImg, CardBody, FormGroup, Label, Input, Button, Spinner } from 'reactstrap';

import { requestToLogin } from '../services';

class Login extends Component {
	state = {
		accessCode: null,
		loading: false
	}

	handleToLogin = async () => {
		const { history } = this.props;
		const params = pick(['accessCode'], this.state);

		try {
			this.setState({ loading: true });

			const { data } = await requestToLogin(params);
			const { establishmentId, typePrice } = data;

			sessionStorage && sessionStorage.setItem('establishmentId', establishmentId);
			sessionStorage && sessionStorage.setItem('typePrice', typePrice);

			this.setState({ loading: false });

			history.push('/ativacao-convenio');
		} catch (err) {
			this.setState({ loading: false });
		} finally {
			this.setState({ loading: false });
		}
	}

	render() {
		const { loading, accessCode } = this.state;

		return(
			<div
        className="h-100 w-100 d-flex align-items-center"
        style={{ backgroundColor: '#022A5C' }}
      >
				<Container>
					<Row>
						<Col md={6} className="mx-auto">
							<Card>
								<CardBody>
									<CardImg
										top
										width="125px"
										height="125px"
										className="mb-3"
										src={require('../../../logo.svg')}
										alt="Jump Park Convênio"
									/>
									<FormGroup>
										<Label>Código de acesso</Label>
										<Input
											placeholder="Digite seu código de acesso"
											onKeyPress={(event) => (event.key === 'Enter' ? this.handleToLogin : null)}
											onChange={(event) => this.setState({ accessCode: event.target.value })}
											disabled={loading}
										/>
									</FormGroup>
									<Button
                    block
                    style={{ backgroundColor: '#13BC4B', borderColor: '#13BC4B' }}
                    disabled={loading || !accessCode}
                    onClick={this.handleToLogin}
                  >
										{loading ? <Spinner size="sm" color="white" /> : 'Entrar'}
									</Button>
								</CardBody>
							</Card>
						</Col>
					</Row>
				</Container>
			</div>
		);
	}
}

export default Login;


// WEBPACK FOOTER //
// ./src/pages/Login/components/Login.js